export const handleUserResponse = (response) => {
    const { status, data } = response?.payload ?? {};

    // Если ответ неуспешный
    if (status !== 200) {
        const rawErrors = data?.errors ?? null;

        // Преобразуем ошибки в плоский объект "поле → сообщение"
        const fieldErrors = rawErrors
            ? Object.entries(rawErrors).reduce((acc, [field, msgs]) => {
                const first = Array.isArray(msgs) ? msgs[0] : msgs;
                if (first) acc[field] = String(first);
                return acc;
            }, {})
            : null;

        const hasFieldErrors = !!(fieldErrors && Object.keys(fieldErrors).length > 0);

        const errorType = hasFieldErrors ? "field" : "general";
        const errorField = hasFieldErrors ? Object.keys(fieldErrors)[0] : null;

        // Общее сообщение берём только если нет конкретных полей
        const generalMessage = !hasFieldErrors
            ? data?.message || "Произошла ошибка."
            : data?.message ?? null;

        return {
            pending: false,
            error: true,
            errorType,        // "field" | "general"
            errorField,       // например: "phone"
            fieldErrors,      // { phone: "Такое значение поля Телефон уже существует" }
            generalMessage,   // сообщение для тоста / общей ошибки
            errorMessage: generalMessage, // алиас, чтобы не ломать старый код
            userData: {
                user: null,
                token: null,
            },
        };
    }

    // Если всё прошло успешно
    return {
        pending: false,
        error: false,
        errorType: null,
        errorField: null,
        fieldErrors: null,
        generalMessage: null,
        errorMessage: null,
        userData: data,
    };
};




export const handleResponse = (response) => {
    if (response.payload.status !== 200) {
        return ({
            pending: false,
            error: true,
            errorMessage: response.payload.data.message,
            success: false,
        })
    }
    const confirmationUrl = response.payload.data.data.url || '';
    return ({
        pending: false,
        error: false,
        errorMessage: null,
        success: true,
        confirmationUrl,
    })
}

export const handleResetPasswordResponse = (action: any) => {
    const status = action?.payload?.status;
    const message =
        action?.payload?.data?.message ??
        "Произошла ошибка при сбросе пароля";

    // 204 — успешный сброс
    if (status === 204) {
        return {
            pending: false,
            error: false,
            errorMessage: null,
            success: true,
        };
    }

    // всё остальное считаем ошибкой
    return {
        pending: false,
        error: true,
        errorMessage: message,
        success: false,
    };
};

